import { useQuery } from "@tanstack/react-query";
import { get } from "#api";
import OrganizationGrid from "./organization_grid";

function Organization() {
  const query = useQuery({
    queryKey: ["users"],
    queryFn: async () => {
      const data = await get(`/user/view`);
      return data;
    },
  });
  return <OrganizationGrid users={query.data} />;
}
export default Organization;
